import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResponse } from 'src/app/invopay/interfaces/ip-page-response';
import { QueryParametersService } from 'src/app/invopay/services/ip-query-parameter.service';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import { FinBusinessPaymentResponse } from '../model/fin-business-payment-response';
import { FinPaymentDetailResponse } from '../model/fin-payment-detail-response';

@Injectable({
  providedIn: 'root',
})
export class FnSuppPaymentsService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) {}

  getPaymentsDone(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    businessName: string
  ): Observable<PageResponse<FinBusinessPaymentResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );
    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (businessName && businessName.trim() !== '') {
      params = params.set('businessName', businessName);
    }
    return this.http.get<PageResponse<FinBusinessPaymentResponse>>(
      this.api + '/invopay/finances-business/payments/payments-made',
      { params }
    );
  }

  getPaymentsSend(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    businessName: string
  ): Observable<PageResponse<FinBusinessPaymentResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );
    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (businessName && businessName.trim() !== '') {
      params = params.set('businessName', businessName);
    }

    return this.http.get<PageResponse<FinBusinessPaymentResponse>>(
      this.api + '/invopay/finances-business/payments/payments-send',
      { params }
    );
  }

  getPaymentDetail(payId: number): Observable<FinPaymentDetailResponse> {
    return this.http.get<FinBusinessPaymentResponse>(
      this.api + `/invopay/finances-business/payment/${payId}`
    );
  }
}
